import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {LoaderService} from '../../shared/services/util/loader.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class SpinnerComponent implements OnInit {

  loading = this.loaderService._loading;

  constructor(public loaderService: LoaderService) {
  }

  ngOnInit(): void {
  }

}
